import { render, staticRenderFns } from "./apply-cert.vue?vue&type=template&id=6f959f82&scoped=true&"
import script from "./apply-cert.vue?vue&type=script&lang=js&"
export * from "./apply-cert.vue?vue&type=script&lang=js&"
import style0 from "./apply-cert.vue?vue&type=style&index=0&id=6f959f82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f959f82",
  null
  
)

export default component.exports